<template>
  <v-main>
    <slot>
      <NuxtPage />
    </slot>
  </v-main>
</template>